import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface HardscapingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Hardscaping: React.FC<HardscapingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [hardscaping, set_hardscaping] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Hardscaping'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Hardscaping': v } } })
    );
    const label = 'Hardscaping';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(hardscaping)}
                />
            ) : (
                <MoneyBox
                    id={'hardscaping'}
                    allowNegative={false}
                    value={hardscaping}
                    onChange={(value) => set_hardscaping(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
